import http from "./httpService";

const apiEndpoint = "/services/app/Domain";

export function getOfficeDomains() {
  return http.get(apiEndpoint + "/Office");
}

export function getGoogleDomains() {
  return http.get(apiEndpoint + "/Google");
}

export function updateOfficeDomains(input) {
  return http.put(apiEndpoint + "/Office", input);
}

export function updateGoogleDomains(input) {
  return http.put(apiEndpoint + "/Google", input);
}
